// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

require('jquery-ui')
require('jquery.animateNumber.min')
require('jquery.countdown.min')
require('jquery.easing.1.3')
require('jquery.magnific-popup.min')
require('jquery.stellar.min')
require('jquery.sticky')
require('jquery.waypoints.min')
require('jquery-migrate-3.0.0')
require('jquery-migrate-3.0.1.min')
require('bootstrap.min')
require('bootstrap-datepicker.min')
require('isotope.pkgd.min')
require('aos')
require("mediaelement-and-player.min")
require("owl.carousel.min")
require("slick.min")
require("typed")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.coFntext('../images', true)
// const imagePath = (name) => images(name, true)
